module.exports = __webpack_public_path__ + "static/media/downloadGreen.a2b386e4.svg";